import { IDeviceStatusCommonInformation } from "@types"
import { protectedApi } from "store/Api"

const actionsCheckDeviceStateApi = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        fetchActionsCheckDeviceState: builder.query<IDeviceStatusCommonInformation[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `actions/check_device_state`,
                }
            },
        }),
    }),

})

export const { useFetchActionsCheckDeviceStateQuery } = actionsCheckDeviceStateApi

